//Initialize Accordion
if (document.querySelector(".accordion-container")) {
  new Accordion(".accordion-container");
}

//Carousel Script
//document.querySelectorAll(".glide__slides")
if (document.querySelector(".glide__slides")) {
  var allSlides = document.querySelectorAll(".glide");
  allSlidesArray = Array.prototype.slice.call(allSlides);
  allSlidesArray.forEach(slide => {
    const glide = new Glide(slide, {
      type: "slider",
      perView: 3,
      perTouch: 1,
      focusAt: "center",
      autoplay: false,
      accessibility: true,
      startAt: 2,
      rewind: false,
      classes: {
        disabledArrow: "glide__arrow--disabled"
      },
      peek: {
        before: 100,
        after: 50
      },
      perSwipe: "|",
      breakpoints: {
        800: {
          perView: 1,
          peek: 0
        }
      }
    }).mount();
  });
}

// $('.glide__arrow--right').on('click', function () {
//   $('.glide__arrow--right').removeClass('disabled');

//   var totalslides = $('.glide__bullet').length;

//   if ($('.glide__bullet')[totalslides - 1].hasClass('glide__bullet--active')) {
//     console.log('last');
//     $('.glide__arrow--right').addClass('disabled');
//   }
// })

//Check if Header Button link is external
if (document.querySelector(".cta-btn")) {
  let currentHost = window.location.hostname;
  let ctaBtn = document.querySelector(".cta-btn");
  let ctaLink = ctaBtn.getAttribute("href").split("/");

  if (ctaLink[0] !== currentHost) {
    ctaBtn.classList.add("external-link");
  }
}

//Menu
$(document).ready(function() {
  "use strict";
  $(".menu-main-menu-container > ul > li:has( > ul)").addClass("menu-dropdown-icon");
  $(".menu-main-menu-container > ul > li > ul:not(:has(ul))").addClass("normal-sub");
  $(".menu-main-menu-container > ul").before('<div class="container"><a href="#" class="menu-mobile"><span></span><span class="screen-reader-text">Menu Toggle</span></a></div>');
  $(".menu-main-menu-container > ul > li").hover(function(e) {
    if ($(window).width() > 943) {
      $(this)
        .children("ul")
        .stop(true, false)
        .fadeToggle(150)
        .attr("aria-expanded", true);
      e.preventDefault();
    }
  });

  $(".menu-main-menu-container > ul > li").click(function() {
    if ($(window).width() <= 943) {
      $(this)
        .children("ul")
        .fadeToggle(150);
    }
  });
  $(".menu-mobile").click(function(e) {
    $(".menu-main-menu-container > ul").toggleClass("show-on-mobile");
    $(".menu-mobile").toggleClass("active-menu");
    $("#overlay").fadeToggle();
    e.preventDefault();
  });
});
$(window).resize(function() {
  $(".menu-main-menu-container > ul > li")
    .children("ul")
    .hide();
  $(".menu-main-menu-container > ul").removeClass("show-on-mobile");
});

let menuSubmenu = document.querySelectorAll(".menu-item-has-children");
allmenuSubmenu = Array.prototype.slice.call(menuSubmenu);
allmenuSubmenu.forEach(menu => {
  let parentName = menu.firstChild.textContent;

  menu.children[0].setAttribute("aria-haspopup", "true");
  menu.children[1].setAttribute("aria-expanded", false);
  menu.children[1].setAttribute("aria-label", parentName + " Submenu");
});

$(".menu-item-has-children > a").on("click", function(e) {
  if (
    $(this)
      .next()
      .css("display") == "none"
  ) {
    e.preventDefault();
    $(this)
      .find(".arrowchevron")
      .addClass("close-submenu");
  } else {
    $(this)
      .find(".arrowchevron")
      .removeClass("close-submenu");
  }
});

var spanChevron = $("<span />")
  .attr("class", "arrowchevron")
  .html("");
$(".menu-item-has-children > a").append(spanChevron);

$(".arrowchevron").on("click", function(e) {
  e.preventDefault();
  if (
    $(this)
      .parent()
      .next()
      .css("display") == "none"
  ) {
    $(this).addClass("close-submenu");
  } else {
    $(this).removeClass("close-submenu");
  }
});

////Pagination
if (document.querySelector(".navigation-pagination")) {
  let paginationList = document.querySelectorAll(".navigation-pagination ul li");

  if (paginationList[0].classList.contains("active")) {
    paginationList[0].style.position = "relative";
  }

  if (paginationList[paginationList.length - 1].classList.contains("active")) {
    paginationList[paginationList.length - 1].style.position = "relative";
  }
}

if ($(".page-heading.only-desktop").length != 0) {
  $("article.page").css("padding", 0);
}

////////Glide
if (document.querySelector(".allcontainer")) {
  var elem = document.querySelector(".allcontainer");
  var msnry = new Masonry(elem, {
    // options
    itemSelector: ".item",
    columnWidth: ".grid-sizer",
    gutter: 30
  });

  msnry.destroy();

  //Filters
  // const filterBtn = document.querySelectorAll('.filters button');
  // var allfilterBtn = Array.prototype.slice.call(filterBtn);
  //let allblocks = document.querySelectorAll('.item');
  let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
  let selectedValue;
  let selectedOption;
  let availableItems;
  let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener("click", onClickChange);
  }

  //Click Filter
  function onClickChange() {
    selectedValue = this.value;

    // if(selectedValue !== 'all'){
    //   allblocks = document.querySelectorAll('.item.block');
    // }
    allblocks.forEach(function(block) {
      block.classList.remove("block");

      if (selectedValue == "all") {
        block.classList.add("block");
      }

      if (block.getAttribute("data-cat") == selectedValue) {
        block.classList.add("block");
      }
    });

    msnry.destroy();
    msnry.layout();

    //availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
    //document.getElementById("select").addEventListener("change", onSelectChange);
  }

  //availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

  //document.getElementById("select").addEventListener("change", onSelectChange);

  function onSelectChange() {
    selectedOption = this.value;

    availableItems.forEach(function(item) {
      item.classList.remove("block");

      if (selectedOption == "all") {
        item.classList.add("block");
      }

      if (item.getAttribute("data-tag") == selectedOption) {
        item.classList.add("block");
      }
    });

    //Filter Click
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", onClickChange);
    }

    msnry.layout();
  }

  /////Script_AJAX
  /* Ajax functions */
  $(document).ready(function() {
    //onclick
    $("#loadMore").on("click", function(e) {
      e.preventDefault();
      //init
      var that = $(this);
      var page = $(this).data("page");
      var newPage = page + 1;
      var ajaxurl = that.data("url");
      //ajax call
      $.ajax({
        url: ajaxurl,
        type: "post",
        data: {
          page: page,
          action: "ajax_script_load_more"
        },
        error: function(response) {
          console.log(response);
        },
        success: function(response) {
          //check
          if (response == 0) {
            $(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
            $("#loadMore").hide();
          } else {
            that.data("page", newPage);
            $("#ajax-primary").append(response);

            msnry = new Masonry(elem, {
              // options
              itemSelector: ".item",
              columnWidth: ".grid-sizer",
              gutter: 30
            });

            msnry.layout();
          }
        }
      });
    });
  });
}

////Gallery Lightbox
// let allGallery = document.querySelectorAll('.wp-block-gallery');

// if (allGallery) {
//   allGallery.forEach(gallery => {
//     gallery.classList += ' gallery-with-modal';
//   });
// }

$("#onetrust-group-container").on("click", "button", function() {
  $(".skip-link").blur();
  $(".custom-logo-link").focus();
});
